export const businesses = [
  {
    id: 1,
    name: '鑫盛达餐饮管理有限公司',
    category: 'canyin-meishi',
    categoryName: '餐饮美食',
    address: '北京市朝阳区建国路88号SOHO现代城A座1205室',
    phone: '010-88886666',
    contact: '张经理',
    email: 'contact@xinshengda.com',
    website: 'www.xinshengda.com',
    description: '鑫盛达餐饮管理有限公司是一家集餐饮品牌运营、连锁加盟、食品研发于一体的综合性餐饮企业，旗下拥有多个知名餐饮品牌，覆盖中式快餐、火锅、烧烤等多个品类。',
    tags: ['连锁餐饮', '品牌加盟', '中式快餐', '火锅'],
    rating: 4.8,
    reviewCount: 326,
    verified: true,
    imageSeq: 'biz-xinshengda',
    featured: true,
  },
  {
    id: 2,
    name: '京华建筑设计研究院',
    category: 'jianzhu-zhuangxiu',
    categoryName: '建筑装修',
    address: '北京市海淀区中关村南大街12号科技大厦15层',
    phone: '010-62223333',
    contact: '李总工程师',
    email: 'info@jinghuajianzhu.cn',
    website: 'www.jinghuajianzhu.cn',
    description: '京华建筑设计研究院拥有甲级建筑设计资质，专业从事公共建筑、住宅小区、商业综合体等项目的规划设计，在行业内具有较高声誉。',
    tags: ['建筑设计', '规划设计', '甲级资质', '商业综合体'],
    rating: 4.6,
    reviewCount: 189,
    verified: true,
    imageSeq: 'biz-jinghua',
    featured: true,
  },
  {
    id: 3,
    name: '博雅教育培训中心',
    category: 'jiaoyu-peixun',
    categoryName: '教育培训',
    address: '上海市浦东新区张江高科技园区碧波路690号',
    phone: '021-68887777',
    contact: '王校长',
    email: 'info@boyajiaoyu.com',
    website: 'www.boyajiaoyu.com',
    description: '博雅教育培训中心致力于为中小学生提供优质的课外辅导服务，开设语文、数学、英语、物理、化学等多门学科辅导课程。',
    tags: ['课外辅导', '学科培训', '中小学教育', '一对一教学'],
    rating: 4.7,
    reviewCount: 452,
    verified: true,
    imageSeq: 'biz-boya',
    featured: true,
  },
  {
    id: 4,
    name: '安康大药房连锁有限公司',
    category: 'yiliao-jiankang',
    categoryName: '医疗健康',
    address: '广州市天河区天河路385号太古汇B2层',
    phone: '020-38889999',
    contact: '陈药师',
    email: 'service@ankangyaofang.com',
    website: 'www.ankangyaofang.com',
    description: '安康大药房是华南地区知名连锁药房品牌，拥有超过200家直营门店，提供药品零售、中药饮片、医疗器械、保健品等一站式健康服务。',
    tags: ['连锁药房', '药品零售', '中药饮片', '保健品'],
    rating: 4.5,
    reviewCount: 567,
    verified: true,
    imageSeq: 'biz-ankang',
    featured: true,
  },
  {
    id: 5,
    name: '美居乐家居建材城',
    category: 'jiaju-shenghuo',
    categoryName: '家居生活',
    address: '深圳市龙华区民治大道518号',
    phone: '0755-29998888',
    contact: '刘经理',
    email: 'sales@meijule.com',
    website: 'www.meijule.com',
    description: '美居乐家居建材城是深圳地区大型一站式家居建材购物中心，汇集国内外知名品牌，涵盖家具、卫浴、瓷砖、地板、灯饰等全品类产品。',
    tags: ['建材市场', '家居卖场', '一站式购物', '品牌家具'],
    rating: 4.3,
    reviewCount: 234,
    verified: false,
    imageSeq: 'biz-meijule',
    featured: true,
  },
  {
    id: 6,
    name: '速达汽车服务有限公司',
    category: 'qiche-jiaotong',
    categoryName: '汽车交通',
    address: '成都市武侯区科华北路153号',
    phone: '028-85556666',
    contact: '赵经理',
    email: 'service@sudaqiche.com',
    website: 'www.sudaqiche.com',
    description: '速达汽车服务有限公司提供专业的汽车维修保养、美容装饰、事故理赔、代办年检等一站式汽车后市场服务，拥有先进的检测设备和专业技师团队。',
    tags: ['汽车维修', '保养服务', '美容装饰', '年检代办'],
    rating: 4.4,
    reviewCount: 312,
    verified: true,
    imageSeq: 'biz-suda',
    featured: false,
  },
  {
    id: 7,
    name: '云游天下国际旅行社',
    category: 'luyou-jiudian',
    categoryName: '旅游酒店',
    address: '杭州市西湖区文三路508号天苑大厦8楼',
    phone: '0571-87778888',
    contact: '孙经理',
    email: 'travel@yunyoutianxia.com',
    website: 'www.yunyoutianxia.com',
    description: '云游天下国际旅行社是浙江省五星级旅行社，提供国内外旅游线路定制、签证办理、会议会展、商务考察等全方位旅游服务。',
    tags: ['国际旅行社', '线路定制', '签证办理', '商务考察'],
    rating: 4.9,
    reviewCount: 678,
    verified: true,
    imageSeq: 'biz-yunyou',
    featured: true,
  },
  {
    id: 8,
    name: '锦尚服饰集团有限公司',
    category: 'fuzhuang-shishang',
    categoryName: '服装时尚',
    address: '东莞市虎门镇富民服装商务中心12层',
    phone: '0769-81112222',
    contact: '黄总经理',
    email: 'info@jinshangfashion.com',
    website: 'www.jinshangfashion.com',
    description: '锦尚服饰集团是一家集设计研发、生产制造、品牌运营于一体的现代化服装企业，旗下拥有多个时尚品牌，产品远销欧美及东南亚市场。',
    tags: ['服装制造', '品牌运营', '外贸出口', '时尚设计'],
    rating: 4.2,
    reviewCount: 156,
    verified: true,
    imageSeq: 'biz-jinshang',
    featured: false,
  },
  {
    id: 9,
    name: '星辰科技股份有限公司',
    category: 'keji-hulianwang',
    categoryName: '科技互联网',
    address: '深圳市南山区科技园南区高新南一道2号',
    phone: '0755-86669999',
    contact: '林技术总监',
    email: 'contact@xingchen-tech.com',
    website: 'www.xingchen-tech.com',
    description: '星辰科技是一家专注于人工智能和大数据领域的高新技术企业，为企业提供智能化解决方案，包括数据分析平台、AI客服系统、智能推荐引擎等产品。',
    tags: ['人工智能', '大数据', 'SaaS平台', '高新技术企业'],
    rating: 4.7,
    reviewCount: 423,
    verified: true,
    imageSeq: 'biz-xingchen',
    featured: true,
  },
  {
    id: 10,
    name: '正和法律咨询服务所',
    category: 'falv-zixun',
    categoryName: '法律咨询',
    address: '南京市鼓楼区中山北路223号建达大厦505室',
    phone: '025-83332222',
    contact: '吴律师',
    email: 'wulvshi@zhenghe-law.com',
    website: 'www.zhenghe-law.com',
    description: '正和法律咨询服务所由资深执业律师团队组成，专业领域涵盖民商事诉讼、合同纠纷、劳动争议、知识产权保护、企业法律顾问等。',
    tags: ['法律咨询', '民事诉讼', '合同纠纷', '企业法务'],
    rating: 4.8,
    reviewCount: 198,
    verified: true,
    imageSeq: 'biz-zhenghe',
    featured: false,
  },
  {
    id: 11,
    name: '汇通金融服务有限公司',
    category: 'jinrong-baoxian',
    categoryName: '金融保险',
    address: '上海市浦东新区陆家嘴环路1000号恒生银行大厦32楼',
    phone: '021-68886666',
    contact: '郑经理',
    email: 'service@huitong-finance.com',
    website: 'www.huitong-finance.com',
    description: '汇通金融是一家综合性金融服务机构，提供企业融资、投资理财、保险代理、资产管理等多元化金融服务，拥有专业的金融分析团队。',
    tags: ['金融服务', '投资理财', '企业融资', '保险代理'],
    rating: 4.5,
    reviewCount: 267,
    verified: true,
    imageSeq: 'biz-huitong',
    featured: false,
  },
  {
    id: 12,
    name: '顺安达物流有限公司',
    category: 'wuliukuaidi',
    categoryName: '物流快递',
    address: '武汉市东西湖区金山大道169号临空港物流园',
    phone: '027-85557777',
    contact: '马经理',
    email: 'info@shunanda-wl.com',
    website: 'www.shunanda-wl.com',
    description: '顺安达物流是华中地区知名的第三方物流服务商，拥有自营车队和现代化仓储设施，提供干线运输、城市配送、仓储管理等一站式物流解决方案。',
    tags: ['物流运输', '仓储管理', '城市配送', '干线运输'],
    rating: 4.3,
    reviewCount: 345,
    verified: true,
    imageSeq: 'biz-shunanda',
    featured: false,
  },
  {
    id: 13,
    name: '味香园餐饮连锁有限公司',
    category: 'canyin-meishi',
    categoryName: '餐饮美食',
    address: '重庆市渝中区解放碑民权路28号英利国际金融中心45层',
    phone: '023-63338888',
    contact: '何总厨',
    email: 'heyue@weixiangyuan.com',
    website: 'www.weixiangyuan.com',
    description: '味香园是重庆本土知名餐饮品牌，主营正宗重庆火锅和川菜，在全国拥有超过80家连锁门店，以地道口味和优质服务赢得消费者喜爱。',
    tags: ['重庆火锅', '川菜', '连锁餐饮', '地道口味'],
    rating: 4.8,
    reviewCount: 892,
    verified: true,
    imageSeq: 'biz-weixiangyuan',
    featured: true,
  },
  {
    id: 14,
    name: '智达教育培训学校',
    category: 'jiaoyu-peixun',
    categoryName: '教育培训',
    address: '西安市雁塔区小寨东路126号百隆广场A座6楼',
    phone: '029-82221111',
    contact: '杨校长',
    email: 'info@zhidajiaoyu.cn',
    website: 'www.zhidajiaoyu.cn',
    description: '智达教育是陕西省知名K12培训机构，提供小学到高中全科辅导服务，采用小班教学和个性化辅导相结合的教学模式，师资力量雄厚。',
    tags: ['K12教育', '全科辅导', '小班教学', '个性化辅导'],
    rating: 4.6,
    reviewCount: 378,
    verified: true,
    imageSeq: 'biz-zhida',
    featured: false,
  },
  {
    id: 15,
    name: '雅居装饰设计工程有限公司',
    category: 'jianzhu-zhuangxiu',
    categoryName: '建筑装修',
    address: '苏州市工业园区星海街200号星海国际广场18层',
    phone: '0512-69996666',
    contact: '周设计师',
    email: 'design@yajuzhuangshi.com',
    website: 'www.yajuzhuangshi.com',
    description: '雅居装饰是一家专注于高端住宅和商业空间设计的装饰公司，提供从方案设计到施工落地的一站式装修服务，在长三角地区拥有良好口碑。',
    tags: ['高端装修', '室内设计', '全案设计', '商业空间'],
    rating: 4.7,
    reviewCount: 234,
    verified: true,
    imageSeq: 'biz-yaju',
    featured: false,
  },
];